<template>
   <div id="subscription-container">
      <h2 class="text-h4">Subscription</h2>
      <div v-if="customerPortalLink">
         <a :href="customerPortalLink" target="_blank"
            >Manage your subscription here.</a
         >
      </div>
      <div v-else>
         <p>Something went wrong. Please contact support@ezbot.ai</p>
      </div>
   </div>
</template>
<script setup lang="ts">
import { Ref, ref, onMounted } from "vue"
import { createStripeCustomerPortalSession } from "@/services/adminBackendClient"

const customerPortalLink: Ref<string | undefined> = ref(undefined)

// Get customer portal URL from backend
const getCustomerPortalUrl = async () => {
   try {
      const response = await createStripeCustomerPortalSession()
      customerPortalLink.value = response.data.url
   } catch (error) {
      console.error("Failed to get customer portal URL:", error)
   }
}

// Get portal URL when component mounts
onMounted(() => {
   getCustomerPortalUrl()
})
</script>
<style lang="scss" scoped>
#subscription-container {
   text-align: left;
}
</style>
